export const ratingChange = (value, questionId) => ({
  type: 'RATING_CHANGE',
  questionId,
  value,
});

export const matrixRatingChange = (value, rowIndex, questionId) => ({
  type: 'RATING_CHANGE',
  questionId,
  rowIndex,
  value,
});
